import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as UserDataConfig from '../config/user-data.config';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';
import { AppState } from '../../../store/state/app.state';
import { Store } from '@ngrx/store';
import { SessionTimeoutService } from 'src/app/shared/services/api-services/session-timeout.service';
import { AnalyticsService } from '../../../shared';
// import {
//   emailValidatorCheck
// } from '../../../shared/directives/custom-check.directive';
@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {
  userForm: UntypedFormGroup;
  headerTitle: string;
  public userInputDetail = UserDataConfig.ElementsConfig;
  enableBreadCrumbFeature:boolean=true;
  enableHeader:boolean=true;
  enableFooter:boolean=true;
  showOnlyRouterOutLetPage=false;
  hideBreadcrumb:boolean =false;
  constructor(private fb: UntypedFormBuilder, private router: Router,private store: Store<AppState>, private _sessionTimeoutSrv: SessionTimeoutService, private analyticsService: AnalyticsService,) {

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        // tslint:disable-next-line: max-line-length
        //console.log(this.router.url);
        if(this.router.url !== '/home/get-your-online-quote' && this.router.url !== '/home/you-will-need' && this.router.url !== '/home/logout') {
          this._sessionTimeoutSrv.resetTimer();
        }

        if ((this.router.url === '/home/registration') || this.router.url === '/home/logout' 
        || this.router.url.includes('/home/get-your-online-quote')) {
          this.enableBreadCrumbFeature = false;
          if (this.router.url.includes('/home/get-your-online-quote') || (this.router.url === '/home/registration')) {
            this.enableBreadCrumbFeature = false;
            this.hideBreadcrumb =true;
          } else {
            this.hideBreadcrumb=false;
          }
        }
        else if (this.router.url.indexOf('/home/un-support') > -1) {
          this.enableHeader = false;
          this.enableBreadCrumbFeature = false;
          this.enableFooter=false;
          this.showOnlyRouterOutLetPage=true;
        }else {
          this.enableBreadCrumbFeature = true;
          this.showOnlyRouterOutLetPage=false;
        }

        // this.analyticsService.pageTrack({ pageName: "OnlineQuote" });
      });
   }

  ngOnInit() {

    

  }
}
